var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.521 10.8382L17.5246 12.6715C17.5273 14.0716 17.5286 14.7717 17.2572 15.307C17.0184 15.7778 16.6367 16.161 16.1667 16.4016C15.6325 16.6751 14.9324 16.6765 13.5323 16.6792L11.6989 16.6827M8.33674 1.68915L6.50341 1.69268C5.10328 1.69537 4.40322 1.69672 3.86896 1.97023C3.39902 2.21082 3.01731 2.59401 2.77853 3.06487C2.50708 3.60018 2.50842 4.30024 2.51112 5.70037L2.51465 7.5337M12.513 6.68112L17.5034 1.6715M17.5034 1.6715L12.5034 1.68113M17.5034 1.6715L17.513 6.67149M7.52266 11.6907L2.53229 16.7003M2.53229 16.7003L7.53228 16.6907M2.53229 16.7003L2.52267 11.7004",
    stroke: "#D0D8DD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0385132) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMap);
export default __webpack_public_path__ + "static/media/expand-map.f3108586f526915b378fffdfb5480b3e.svg";
export { ForwardRef as ReactComponent };